import { render, staticRenderFns } from "./BoolBox.vue?vue&type=template&id=363f4147&scoped=true&"
import script from "./BoolBox.vue?vue&type=script&lang=js&"
export * from "./BoolBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f4147",
  null
  
)

export default component.exports